import Vue from 'vue'
import Router from 'vue-router'
import asyncRouter from './asyncRouter'

Vue.use(Router)

export default new Router({
  base: process.env.VUE_APP_ROUTER,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/home')
    },
    {
      path: '/user',
      name: 'User',
      meta: {
        name: '用户首页',
        type: 'user'
      },
      redirect: '/user/home'
    },
    {
      path: '/user/home',
      name: 'UserHome',
      meta: {
        name: '用户首页',
        type: 'user'
      },
      component: () => import('@/views/home/user')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/404')
    },
    {
      path: '*',
      redirect: '/404'
    },
    ...asyncRouter
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js